module.exports = __webpack_public_path__ + "img/Frage2_2048x1536.e2836678.jpg";